import PropTypes from 'prop-types';
import { Set as ImmutableSet } from 'immutable';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIPanel from 'UIComponents/panel/UIPanel';
import UIPanelBody from 'UIComponents/panel/UIPanelBody';
import UIPanelFooter from 'UIComponents/panel/UIPanelFooter';
import UIPanelHeader from 'UIComponents/panel/UIPanelHeader';
import ApplyFiltersButton from './ApplyFiltersButton';
import CancelButton from './CancelButton';
import DateRange from '../../models/DateRange';
import DateRangeSelect from './DateRangeSelect';
import DialogCloseButton from './DialogCloseButton';
import IncludeChatAndPhoneTicketsCheckbox from './IncludeChatAndPhoneTicketsCheckbox';
import IncludeOpenTicketsCheckbox from './IncludeOpenTicketsCheckbox';
import LanguageSelect from './LanguageSelect';
import ProductAreaSelect from './ProductAreaSelect';
import TicketOwnerSelect from './TicketOwnerSelect';
import { applyFilters } from '../../actions/FiltersActions';
import { searchTickets } from '../../actions/TicketActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TicketFiltersPanel(props) {
  const dispatch = useDispatch();
  const globalFilters = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.filters);
  const searchTerms = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.searchTerms);
  const [filters, setFilters] = useState(globalFilters);
  return /*#__PURE__*/_jsxs(UIPanel, {
    width: 320,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      "data-test-id": "ticket-filters-dialog-close-button",
      onClick: props.onClose
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ className: string; "data-test-id": string;... Remove this comment to see the full error message
      ,
      className: "m-right-3"
    }), /*#__PURE__*/_jsx(UIPanelHeader, {
      children: /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "title",
          message: "app.filter.panel.title"
        })
      })
    }), /*#__PURE__*/_jsxs(UIPanelBody, {
      className: "p-all-3",
      children: [/*#__PURE__*/_jsx("div", {
        className: "p-x-3",
        children: /*#__PURE__*/_jsx(DateRangeSelect, {
          "data-test-id": "ticket-filters-date-range-select",
          onSelect: value => setFilters(filters.set('dateRange', new DateRange(value)))
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "p-top-3 p-x-3",
        children: /*#__PURE__*/_jsx(LanguageSelect, {
          "data-test-id": "ticket-filters-language-select",
          onSelect: value => setFilters(filters.set('languages', ImmutableSet(value)))
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "p-top-3 p-x-3",
        children: /*#__PURE__*/_jsx(ProductAreaSelect, {
          "data-test-id": "ticket-filters-product-area-select",
          onSelect: value => setFilters(filters.set('productAreas', ImmutableSet(value)))
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "p-top-3 p-x-3",
        children: /*#__PURE__*/_jsx(TicketOwnerSelect, {
          "data-test-id": "ticket-filters-ticket-owner-select",
          onSelect: value => setFilters(filters.set('ticketOwners', ImmutableSet(value)))
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "p-top-5 p-left-3",
        children: /*#__PURE__*/_jsx(IncludeOpenTicketsCheckbox, {
          "data-test-id": "ticket-filters-include-open-tickets",
          onCheck: value => setFilters(filters.set('includeOpenTickets', value))
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "p-top-3 p-left-3",
        children: /*#__PURE__*/_jsx(IncludeChatAndPhoneTicketsCheckbox, {
          "data-test-id": "ticket-filters-include-chat-and-phone-tickets",
          onCheck: value => setFilters(filters.set('includeChatAndPhoneTickets', value))
        })
      })]
    }), /*#__PURE__*/_jsxs(UIPanelFooter, {
      style: {
        padding: '22px'
      },
      children: [/*#__PURE__*/_jsx(ApplyFiltersButton, {
        "data-test-id": "ticket-filters-apply-filters-button",
        isDisabled: filters.equals(globalFilters),
        onClick: () => {
          dispatch(applyFilters(filters));
          dispatch(searchTickets(searchTerms, filters, 'filters-applied'));
          props.onClose();
        }
      }), /*#__PURE__*/_jsx(CancelButton, {
        "data-test-id": "ticket-filters-cancel-button",
        onClick: props.onClose
      })]
    })]
  });
}
TicketFiltersPanel.propTypes = {
  onClose: PropTypes.func.isRequired
};
export default TicketFiltersPanel;